import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode, useContext } from "react";
import { useDraggable } from '@dnd-kit/core';
import { makeBoxStyles } from "system/query/QueryUtility";
import { BuilderContext } from "components/queries/QueryBuilderPanel";

export interface QueryBuilderContainerBoxProps {
  path?: string;
  draggable?: boolean;
  isActiveDropTarget?: boolean;
  borderColor: string;
  borderColorTop: string;
  backgroundColor: string;
  onClick?: () => void;
  children?: ReactNode;
}

export function QueryBuilderContainerBox(props: QueryBuilderContainerBoxProps): JSX.Element {
  const {draggingIsDisabled} = useContext(BuilderContext);

  const {isDragging, attributes, listeners, setNodeRef, transform} = useDraggable({
    id: props.path || '.',
    disabled: !props.draggable || draggingIsDisabled
  });

  const sxProps:SxProps<Theme> = makeBoxStyles(props.backgroundColor, props.borderColor, props.borderColorTop,
    props.isActiveDropTarget, transform, false, isDragging);

  const innerSXProps = {...sxProps};
  delete innerSXProps.transform;
  delete innerSXProps.zIndex;
  delete innerSXProps.opacity;

  const containerSX:SxProps<Theme> = {
    transform: sxProps.transform || undefined,
    zIndex: sxProps.zIndex || undefined,
    opacity: sxProps.opacity || undefined,
    position: 'relative',
    minWidth: '300px',
    maxWidth: '100%',
    padding: "0px 2px 6px 14px",
    '&:before': {
      ...innerSXProps,
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      width: '330px',
      maxWidth: '100%',
      content: '""',
    }

  }

  return (
    <Box
      sx={{...containerSX}}
      {...listeners}
      {...attributes}
      ref={setNodeRef}
      onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (props.onClick) {
          event.stopPropagation();
          props.onClick();
        }
      }}>
      <Box sx={{position:'relative', p:0, width:'100%'}}>
        {props.children}
      </Box>
    </Box>
  );
}